<!-- eslint-disable -->
<template lang="pug">
    div(@mousedown.prevent="")
        datepicker-header(
            :previousTime="previousMonth"
            :nextTime="nextMonth"
            :showCalendar="showMonthCalendar"
            :headerText="((isYmd ? currYearName : currMonthName) + ' ') + ((isYmd ? currMonthName : currYearName) + '')"
            :clickable="true"
        )
        datepicker-calendar(
            time="Day"
            :items="days"
            :select="selectDate"
            :blankDays="blankDays"
            :daysOfWeek="daysOfWeek"
        )
</template>

<script>
    /*eslint-disable*/
    import PickerDay from "../../../node_modules/vuejs-datepicker/src/components/PickerDay.vue"
    import DatepickerHeader from "./DatepickerHeader.vue"
    import DatepickerCalendar from "./DatepickerCalendar.vue"

    export default {
        name: "PickerDay",
        status: "ready",
        release: "1.0.0",
        extends: PickerDay,
        components: {
            DatepickerHeader,
            DatepickerCalendar,
        },
    }
</script>
